export default __webpack_public_path__ + "static/media/admin-graph-main.941d93c6.png";